import { apiClient } from "../lib/api";

export const driveReadinessApi = {
  health: () => apiClient.get("/timekeeping/drive"),
  listMonths: () => apiClient.get("/timekeeping/drive/months"),
  getMonth: (month) => apiClient.get(`/timekeeping/drive/months/${month}`),
  scanMonth: (month) => apiClient.post(`/timekeeping/drive/months/${month}/scan`),
  lockMonth: (month) => apiClient.post(`/timekeeping/drive/months/${month}/lock`),
};
